import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

currentShippingAddressStyles.useBillingAddress = {
    button: {
        color: "secondary",
        css: css`
            margin-top: 20px;
            border-radius: 0px;
            padding: 10px 34px;
            background: ${getColor("common.background")};
            border: 2px solid ${getColor("primary")} !important;
            span[class^="TypographyStyle"] {
                color: ${getColor("primary")};
                font-size: 14px;
                line-height: ${TYPOGRAPHY.lineHeight.base};
            }
            &:hover {
                opacity: 0.3;
                background: none !important;
            }
        `,
    },
};
